module.exports = __webpack_public_path__ + "media/images/team/AlziraAlbuquerque-e571a0bbf3e4518872e134a6cd7a12a6.png";